import React from 'react';
import { Helmet } from 'react-helmet';
import DigitalMarketing from './DigitalMarketing';

const DigitalMarketingPage = () => (
  <>
    <Helmet>
      <title>Digital Marketing in Dubai | SEO, PPC & Branding Experts</title>
      <meta
        name="description"
        content="Enhance your business with the best digital marketing in Dubai. MilaajBrandset provides professional SEO, PPC, and social media services specifically for Dubai businesses."
      />
      <meta
        name="keywords"
        content="digital marketing in Dubai, Dubai SEO agency, PPC Dubai, social media marketing Dubai, online advertising, branding in Dubai, MilaajBrandset"
      />
      <meta property="og:title" content="Digital Marketing in Dubai | MilaajBrandset Experts" />
      <meta
        property="og:description"
        content="Dominate your space with top-class digital marketing in Dubai. Whether it's SEO or paid advertisements, MilaajBrandset makes your company grow faster on the internet"
      />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://www.milaajbrandset.com/digital-marketing" />
    </Helmet>
    <DigitalMarketing />
  </>
);

export default DigitalMarketingPage;